import { useEffect, useRef, useState } from 'react';

interface PageHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalPath: string;
  ogImage?: string;
  ogType?: string;
}

export default function PageHead({
  title,
  description,
  keywords,
  canonicalPath,
  ogImage,
  ogType = 'website',
}: PageHeadProps) {
  const [lastModified] = useState(() => new Date().toISOString().split('T')[0]);
  const headRef = useRef<HTMLHeadElement | null>(null);

  useEffect(() => {
    headRef.current = document.head;

    const setMeta = (selector: string, attr: string, value: string) => {
      let el = document.querySelector(selector) as HTMLElement | null;
      if (!el) {
        el = document.createElement('meta');
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    document.title = title;
    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[name="keywords"]', 'content', keywords);
    setMeta('link[rel="canonical"]', 'href', `https://www.tianyoucomics.com${canonicalPath}`);
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:type"]', 'content', ogType);
    setMeta('meta[property="og:url"]', 'content', `https://www.tianyoucomics.com${canonicalPath}`);
    if (ogImage) {
      setMeta('meta[property="og:image"]', 'content', ogImage);
    }
    setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
    setMeta('meta[name="twitter:title"]', 'content', title);
    setMeta('meta[name="twitter:description"]', 'content', description);
    setMeta('meta[name="last-modified"]', 'content', lastModified);
  }, [title, description, keywords, canonicalPath, ogImage, ogType, lastModified]);

  return null;
}